module.exports = global["angular"] = require("-!./index.js");


//////////////////
// WEBPACK FOOTER
// ../~/angular/index.js-exposed
// module id = 20
// module chunks = 3